import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_a4b1710a-e8aa-40f2-90ed-6aa15c96d321/artifacts/w14lowsf_Disen%CC%83o%20sin%20ti%CC%81tulo.png";

// Use relative URL for API calls so it works on any domain
const getApiUrl = () => {
  // If we're on the preview domain, use the env variable
  // Otherwise use relative URLs (same domain)
  if (window.location.hostname.includes('preview.emergentagent.com')) {
    return process.env.REACT_APP_BACKEND_URL || '';
  }
  return ''; // Use relative URLs for production
};

const ModeloLogin = () => {
  const navigate = useNavigate();

  // Check for session token in URL (from Google OAuth callback)
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const sessionToken = params.get('session');
    if (sessionToken) {
      localStorage.setItem("jglinks_session", sessionToken);
      window.history.replaceState({}, document.title, window.location.pathname);
      navigate("/modelo/dashboard");
      return;
    }
    
    // Check if already logged in
    const existingSession = localStorage.getItem("jglinks_session");
    if (existingSession) {
      // Verify session is still valid
      verifySession(existingSession);
    }
  }, [navigate]);

  const verifySession = async (token) => {
    try {
      const response = await fetch(`${getApiUrl()}/api/auth/me`, {
        headers: { "Authorization": `Bearer ${token}` }
      });
      if (response.ok) {
        navigate("/modelo/dashboard");
      } else {
        localStorage.removeItem("jglinks_session");
      }
    } catch (e) {
      // Session invalid, stay on login page
    }
  };

  // Google Login
  const handleGoogleLogin = () => {
    window.location.href = `${getApiUrl()}/api/auth/google/login`;
  };

  return (
    <div className="min-h-screen bg-black flex flex-col">
      {/* Header */}
      <header className="p-6">
        <Link to="/">
          <img src={LOGO_URL} alt="JG Models" className="h-10" />
        </Link>
      </header>

      {/* Main Content */}
      <main className="flex-1 flex items-center justify-center p-6">
        <div className="w-full max-w-md text-center">
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-white mb-2">
              Bienvenida a JGlinks
            </h1>
            <p className="text-white/60">
              Inicia sesión para gestionar tu perfil
            </p>
          </div>

          {/* Google Login */}
          <Button
            onClick={handleGoogleLogin}
            className="w-full h-14 bg-white hover:bg-white/90 text-black text-base font-medium"
          >
            <svg className="w-5 h-5 mr-3" viewBox="0 0 24 24">
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
              <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
            </svg>
            Continuar con Google
          </Button>

          <p className="text-white/40 text-sm mt-6">
            Al continuar, aceptas nuestros términos y condiciones
          </p>
          
          <div className="mt-8 pt-8 border-t border-white/10">
            <p className="text-white/40 text-sm">
              ¿Primera vez aquí? Al iniciar sesión con Google se creará tu cuenta automáticamente
            </p>
          </div>
        </div>
      </main>
    </div>
  );
};

export default ModeloLogin;
